<template>
    <div id="entire_app__booking_scan">
        <div v-if="loading_qr_data" class="qr_code_container my-qur">
            <img src="../../../assets/qrcode_loading.gif" alt="">
        </div>
        <div v-if="!loading_qr_data" class="qr_code_container my-qur" id="my-qur">
            <QRCodeVue3
                :width="230"
                :height="230"
                :value="$store.state.Booking.qrcodeData"
                :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: errorCorrectionLevelCustom }"
                :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                :dotsOptions="{
                    type: 'extra-rounded',
                    color: '#16191C',
                    gradient: {
                    type: 'linear',
                    rotation: 0,
                    colorStops: [
                        { offset: 0, color: '#16191C' },
                        { offset: 1, color: '#487FFF' },
                    ],
                    },
                }"
                :backgroundOptions="{ color: '#ffffff' }"
                :cornersSquareOptions="{ type: 'extra-rounded', color: '#487FFF' }"
                :cornersDotOptions="{ type: undefined, color: '#487FFF' }"
                fileExt="png"
                :download="false"
                myclass="my-qur"
                imgclass="img-qr"
                downloadButton="my-button"
                :downloadOptions="{ name: 'bookinga_ticket_qr_code', extension: 'png' }"
            />
            
        </div>
        <div class="download_case">
            <p>Please download you ticket Qrcode to use offline in case!</p>
            <div class="btns_scan">
                <button :disabled="downloading_qr" @click="onDownloadClick" class="download">
                    <span v-if="!downloading_qr"> Download Qr code </span>
                    <span v-if="downloading_qr"> Downloading . . . </span>
                    <svg v-if="!downloading_qr" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 22.015 20.414">
                        <path id="Path_174" data-name="Path 174" d="M13,13v5.585l1.828-1.828,1.415,1.415L12,22.414,7.757,18.172l1.415-1.415L11,18.585V13ZM12,2a7,7,0,0,1,6.954,6.194A5.5,5.5,0,0,1,18,18.978V16.964a3.5,3.5,0,1,0-1.112-6.911,5,5,0,1,0-9.777,0,3.5,3.5,0,0,0-1.292,6.88l.18.03v2.014A5.5,5.5,0,0,1,5.046,8.194,7,7,0,0,1,12,2Z" transform="translate(-0.993 -2)" fill="#fff"/>
                    </svg>
                </button>
                <button @click="$store.commit('Booking/closeScanner')" class="close">Close qr code</button>
            </div>
        </div>
    </div>
</template>

<script>
    import QRCodeVue3 from "qrcode-vue3";
    import * as htmlToImage from 'html-to-image';

    export default {
        name: 'BookingScan',
        data() {
            return {
                size: 220,
                downloading_qr: false,
                errorCorrectionLevelCustom: 'L',
                loading_qr_data: false
            }
        },

        components: {
            // QrcodeVue,
            QRCodeVue3
        },
        methods: {
            async onDownloadClick() {

                this.downloading_qr = true;
                this.loading_qr_data = true;
                this.errorCorrectionLevelCustom = 'H';
                let count = 0;
                const loading_qr_data_inter = setInterval(() => {
                    if (count >= 1) {
                        this.loading_qr_data = false;
                        if (count == 2) {
                            if (!this.loading_qr_data) {
                                var departure = this.$store.state.Booking.qrcodeData.split("*")[5];
                                var destination = this.$store.state.Booking.qrcodeData.split("*")[6];
                                var time = this.$store.state.Booking.qrcodeData.split("*")[9];
                                var date = this.$store.state.Booking.qrcodeData.split("*")[4];
                                htmlToImage.toJpeg(document.getElementById('my-qur'), { quality: 0.99 })
                                    .then(function (dataUrl) {
                                        var link = document.createElement('a');
                                        link.download = `${departure}-${destination}-${date}-${time}-bookinga.jpeg`;
                                        link.href = dataUrl;
                                        link.click();
                                    })
                                
                            } else {
                                this.downloading_qr = false;
                                this.loading_qr_data = false;
                                alert('Downloading Qrcode failed. Try again!')
                            }
                            clearInterval(loading_qr_data_inter);
                        }
                    }
                    count++;  
                }, 3000)

                let count_out = 0;
                const stopAllInter = setInterval(() => {
                    if (count_out > 2) {
                        if (count_out > 15) {
                            this.downloading_qr = false;
                            this.loading_qr_data = false;
                            this.errorCorrectionLevelCustom = 'L';
                            clearInterval(stopAllInter);
                        }
                    }
                    count_out++;
                }, 3000)

            },
        }

    }       
   
</script>

<style lang="scss" scoped>
    #entire_app__booking_scan {
        width: 98%;
        // height: 75vh;
        height: 65vh;
        transition: all .5s ease;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .qr_code_container {
            width: auto;
            height: auto;
            padding: 0.7em;
            border-radius: 0.5em;
            border: 0.18em solid #487fff21;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: -2em;

            .my-qur {
                border: none !important;
            }
        }

        .download_case {
            width: 100%;
            height: auto;

            p {
                font-family:satoshi, $poppins;
                color: $mainDark;
                opacity: 0.6;
                margin-top: -3em;
                font-size: 0.82em;
                text-align: center;
            }

            .btns_scan {
                width: 100%;
                height: auto;
                display: flex;
                justify-content: space-between;

                .close {
                    width: 45% !important;
                    color: $mainDark;
                    background: $routeShadows;
                    border-radius: 0.25em;
                    border: none;
                    padding: 0.9em 2em;
                    font-size: 0.88em;
                    margin: auto;
                    margin-top: 1.3em;
                    font-family:satoshi, $poppins;
                    font-weight: 400;
                }

                .download {
                    width: 50%;
                    color: $pureWhite;
                    background: $mainBlue;
                    border-radius: 0.25em;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    padding: 0.6em 2em;
                    font-size: 0.88em;
                    margin: auto;
                    margin-top: 1.3em;
                
                    svg {
                        margin-left: 0.5em;
                        margin-top: 0.3em;
                    }
                }
            }

        }
    }
</style>